import React from "react";
import PanelGroupController from "../../components/PanelGroupController";
import {cx} from "../../lib/ClassSet";
// Looks like a shipping order's Fulfillment Status.
import "../../shipping/panels/ShippingStatusPanel.scss";

// The lifecycle of a stock movement document as a row of steps: earlier ones
// completed, the current one highlighted. A cancelled document shows
// `cancelledText` instead.
const StatusStepsPanel = ({title, steps, status, cancelledText}) => {
  if (!status) return null;

  if (status === "cancelled") {
    return (
      <div className="ShippingStatusPanel">
        <p>{cancelledText}</p>
      </div>
    )
  }

  const current = steps.findIndex((step) => step.id === status);
  return (
    <div className="ShippingStatusPanel">
      <PanelGroupController title={title} expanded={true}>
        {steps.map((step, index) => (
          <div key={step.id} className={cx({"State": true, "u-current": index === current, "u-completed": index < current})}>
            <div className="title">{step.title}</div>
          </div>
        ))}
      </PanelGroupController>
    </div>
  )
}

export default StatusStepsPanel;
